import React from 'react'
import { TextField } from '@radix-ui/themes'
import {Replacement, useMask} from '@react-input/mask'
export interface MaskInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    mask: string | undefined,
    replacement: string | Replacement | undefined
}


export default function MaskInput(props: MaskInputProps ) {
    const {mask, replacement, ...other} = props
    const ref = useMask({
        mask: mask,
        replacement: replacement,
    })
    return (
     <TextField.Root ref={ref} {...other} />
    )
}